import Typography from '@mui/material/Typography';
import {useDispatch, useSelector} from 'react-redux';
import {routeSelector} from '@app/router/redux';
import {makeStyles} from '@mui/styles';
import {bypassExpenseStateSelector} from '@app/screens/module-specific-utilities/pages/bypass-expense/redux/selectors';
import {bypassExpenseStateActions} from '@app/screens/module-specific-utilities/pages/bypass-expense/redux';
import {ActiveInActiveToggle} from '../status-manager';
import theme from '@app/themes';

const useStyles = makeStyles({
  container: {
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
  },
  flexSpaceBetween: {
    display: 'flex',
    justifyContent: 'space-between',
    flexDirection: 'row',
  },
});

export const ByPassExpenseNavBar = () => {
  const dispatch = useDispatch();
  const navbarComponentHeading = useSelector(
    routeSelector.getNavbarComponentHeading(),
  );
  const status = useSelector(bypassExpenseStateSelector.getActiveStatus());
  const classes = useStyles();

  const activeInactive = (event: React.ChangeEvent<HTMLInputElement>) => {
    dispatch(bypassExpenseStateActions.setActiveStatus(event?.target?.checked));
  };

  return (
    <div className={classes.container}>
      <div className={classes.flexSpaceBetween}>
        <Typography
          variant="h6"
          noWrap
          component="div"
          color={theme.colors.LIGHT_NAVY_BLUE}
          fontWeight={theme.sizing.weight800}>
          {navbarComponentHeading}
        </Typography>
      </div>
      {/* <ActiveInActiveToggle status={status} activeInactive={activeInactive} /> */}
    </div>
  );
};
